import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import Properties from '../component/Properties';
import '../css/mediaCss.css';
import styles from '../css/styles.css.js';
import { AppSetting, AppProperties } from '../common/function';

// let appProperties = new Properties();
// let baseFolder = appProperties.baseFolder;
export default class BreadCrumb extends Component {
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;
  constructor(props) {
    super(props);
    this.state = {
      crumbs: []
    };
  }

  render() {
    let openLink = onclickPath => {
      console.debug('BreadCrumb - ', this.baseFolder + onclickPath);
      browserHistory.push(this.baseFolder + onclickPath);
    };

    console.debug("this.state.crumbs>>", this.state.crumbs)
    return (
      <ul style={this.props.Style} className="breadCrumbULStyle">
        {this.state.crumbs !== undefined
          ? this.state.crumbs.map((item, index) => {
            if (item && item.name !== 'undefined') {
              return (
                <li className='breadcrumbHeader' key={index} style={styles.breadcrumb.li.style}>
                  <span style={styles.breadcrumb.li.itemTypeSpan.style}>
                    {item.type}
                  </span>
                  <br />
                  <button  style={styles.breadcrumb.li.itemNameSpan.style} className='ButtonLink' onClick={() => openLink(item.onclickPath)}>{item.name}</button>
                   &nbsp;
                </li>
              );
            }
            })
          : ''}
      </ul>
    );
  }
}
